import {dropdownNodes} from './dropdownNodes';

const settings = ({
  api: {
    url: '/api/search/pages?query={query}',
    resultSelectorJSONata: '$.content[].{\'name\': title, \'value\': id, \'description\': snippetHtml, \'descriptionVertical\': true, \'text\': title, \'link\': \'/pages/\' & id}',
  },
});

export const pageNodes = view => dropdownNodes({
  view, id: 'page', name: 'page', text: 'Page', settings,
});

export const pagesNodes = view => dropdownNodes({
  view, id: 'pages', name: 'pages', text: 'Pages', settings, multiple: true,
});
